import { render, staticRenderFns } from "./editMonitorCAA.vue?vue&type=template&id=229bb3da&scoped=true&"
import script from "./editMonitorCAA.vue?vue&type=script&lang=js&"
export * from "./editMonitorCAA.vue?vue&type=script&lang=js&"
import style0 from "./editMonitorCAA.vue?vue&type=style&index=0&id=229bb3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229bb3da",
  null
  
)

export default component.exports